﻿import { IEditor } from "../interface/editor";
import { ValidatorError } from "../types/validator-error";
import { ValidatorFn } from "../types/validator-fn";
import { ValidatorParam } from "../interface/validator-param";
import { isValidatorDisabled } from "./is-validator-disabled";


export interface compareValiatorParam extends ValidatorParam {
    compareField: string
}

export function compareValidator(param: compareValiatorParam): ValidatorFn {

    return (editor: IEditor): ValidatorError | null => {
        if (isValidatorDisabled(param, editor)) {
            return null;
        }

        let message='Validate Failed';
        if(param.message) {
            message= param.message;
        }

        const compareValue = editor.form?.value[param.compareField];
        if (editor.value !== compareValue) {
            return {  message: message };
        }

        return null;
    };
}

